import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  label {
    .MuiFormControlLabel-label {
      font-weight: 400;
      font-size: 14px;
      color: ${theme.palette.secondary.main};
    }
  }

  .MuiSwitch-switchBase.Mui-checked {
    > .MuiSwitch-thumb {
      background-color: ${theme.palette.primary.main};
      border-color: ${theme.palette.primary.main} !important;
    }

    + .MuiSwitch-track {
      background-color: ${theme.palette.primary.main} !important;
      border-color: ${theme.palette.primary.main} !important;
      opacity: 0.5;
    }
  }
`;
